import React, { useEffect, useState } from 'react';
import Router, { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { useDashboardType, useUser } from '../../../hooks';
import { getViewMode } from 'store/auth';
import classnames from 'classnames';
import { TbCalendarTime } from 'react-icons/tb';
import CompanyMenu from './CompanyMenu';
import { isMobile } from 'react-device-detect';
import {
  homeRoutePath,
  dashboardRoutePath,
  courseRoutePath,
  myLearningPath,
  intakeRoutePath,
  USER_ROLES,
} from 'constants/constants';
import { getColorMenu } from 'store/settings';
import {
  MdOutlineBackupTable,
  MdOutlineHome,
  MdOutlineLocalLibrary,
  MdOutlineSpaceDashboard,
} from 'react-icons/md';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Space } from 'antd';
import { MdOutlineDashboard } from 'react-icons/md';
import { IoPersonAddSharp } from 'react-icons/io5';
import { IoIosArrowDown } from 'react-icons/io';
import { usePermissions } from 'hooks/permission/use-has-permission';
import { permissionOnboard } from 'modules/Home/Onboard/constants';
import { havePermissions } from 'helpers';
import { userAccessType } from 'constants/header';
const Header = (props) => {
  const {
    homeClick,
    dashboardClick,
    onboardDashboard,
    previewHandler,
    courseClick,
    companyClick,
    mylearningClick,
  } = props;
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const viewMode = useSelector(getViewMode);
  const user = useUser();
  const router = useRouter();
  const [checkPermission] = usePermissions(permissionOnboard);
  const dashboardType = useDashboardType();

  const schedulePermission = havePermissions(
    userAccessType?.schedule,
    user,
    viewMode,
  );
  const classPermission = havePermissions(
    userAccessType?.classes,
    user,
    viewMode,
  );
  const dashboardPermission = havePermissions(
    userAccessType?.manageStaffRequest,
    user,
    viewMode,
  );
  const financePermission = havePermissions(
    userAccessType?.pointsType,
    user,
    viewMode,
  );
  const staffTypePermission = havePermissions(
    [...userAccessType.manageStaffRequest, ...userAccessType.staffRequest],
    user,
    viewMode,
  );

  const cenreBlPermission = havePermissions(
    userAccessType.staffRequest,
    user,
    viewMode,
  );

  const menuColor = useSelector(getColorMenu);
  const menuItems = (
    <Menu>
      <Menu.Item onClick={() => onboardDashboard('lms')}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            '--menu-bg-clr': menuColor,
            color: homeRoutePath.includes(Router?.pathname) ? menuColor : '',
          }}
        >
          <MdOutlineDashboard />
          LMS Dashboard
        </div>
      </Menu.Item>
      <Menu.Item onClick={() => onboardDashboard('onboarding')}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            '--menu-bg-clr': menuColor,
            color: homeRoutePath.includes(Router?.pathname) ? menuColor : '',
          }}
        >
          <IoPersonAddSharp />
          Onboard Dashboard
        </div>
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      {metaData?.cmsHomePage && (
        <div
          className={
            (`${isMobile ? '' : 'pl-3'} `,
            'header__nav-link',
            'header-menu-res',
            'home-top')
          }
        >
          <div
            className="header-item
                          cursor-pointer"
            style={{
              display: 'flex',
              '--menu-bg-clr': menuColor,
              color: homeRoutePath.includes(Router?.pathname) ? menuColor : '',
            }}
            onClick={homeClick}
          >
            <MdOutlineHome
              className="header-icon-res"
              style={{ fontSize: 18 }}
            />
            <span className="home-icon header-text-style">Home</span>
          </div>
        </div>
      )}

      {(dashboardPermission && user?.type.name === 'HR') ||
      (financePermission && user?.type.name === 'FINANCE') ? (
        <>
          {user?._id && (
            <div
              className={
                (`${isMobile ? '' : 'pl-3'} `,
                'header__nav-link dashboard-left')
              }
            >
              <div
                className="header-item
                            cursor-pointer"
                style={{
                  display: 'flex',
                  '--menu-bg-clr': menuColor,
                  color: dashboardRoutePath.includes(Router?.pathname)
                    ? menuColor
                    : '',
                }}
                onClick={dashboardClick}
              >
                <IoPersonAddSharp
                  className="header-icon-res"
                  style={{ fontSize: 16 }}
                />
                <span className="home-icon header-text-style text-nowrap">
                  Onboard Dashboard
                </span>
              </div>
            </div>
          )}
        </>
      ) : (staffTypePermission && viewMode === USER_ROLES.ADMIN) ||
        (cenreBlPermission && viewMode === USER_ROLES.CENTRE_BL) ? (
        <>
          {user?._id && (
            <div
              className={
                (`${isMobile ? '' : 'pl-3'} `,
                'header__nav-link dashboard-left')
              }
            >
              <div
                className="header-item
                            cursor-pointer"
                style={{
                  display: 'flex',
                  '--menu-bg-clr': menuColor,
                  color: dashboardRoutePath.includes(Router?.pathname)
                    ? menuColor
                    : '',
                }}
              >
                <MdOutlineSpaceDashboard
                  className="header-icon-res"
                  style={{ fontSize: 16 }}
                />

                <Dropdown
                  overlayStyle={{
                    '--menu-bg-clr': menuColor,
                    color: dashboardRoutePath.includes(Router?.pathname)
                      ? menuColor
                      : '',
                  }}
                  overlay={menuItems}
                  trigger={['click']}
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space
                      className="schedule-icon header-text-style"
                      style={{
                        '--menu-bg-clr': menuColor,
                        color: dashboardRoutePath.includes(Router?.pathname)
                          ? menuColor
                          : '',
                      }}
                    >
                      {dashboardType === 'onboarding'
                        ? 'Onboard Dashboard'
                        : 'LMS Dashboard'}
                      <IoIosArrowDown />
                    </Space>
                  </a>
                </Dropdown>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {user?._id && (
            <div
              className={
                (`${isMobile ? '' : 'pl-3'} `,
                'header__nav-link dashboard-left')
              }
            >
              <div
                className="header-item
                            cursor-pointer"
                style={{
                  display: 'flex',
                  '--menu-bg-clr': menuColor,
                  color: dashboardRoutePath.includes(Router?.pathname)
                    ? menuColor
                    : '',
                }}
                onClick={dashboardClick}
              >
                <MdOutlineSpaceDashboard
                  className="header-icon-res"
                  style={{ fontSize: 16 }}
                />
                <span className="home-icon header-text-style text-nowrap">
                  My Dashboard
                </span>
              </div>
            </div>
          )}
        </>
      )}

      {viewMode !== 'LEARNER' && (
        <>
          {schedulePermission ? (
            <div className={(`${isMobile ? '' : 'pl-3'} `, 'header__nav-link')}>
              <div
                className="header-item
                          cursor-pointer"
                onClick={previewHandler}
                style={{
                  display: 'flex',
                  '--menu-bg-clr': menuColor,
                }}
              >
                <TbCalendarTime
                  style={{ fontSize: 16 }}
                  className="header-icon-res"
                />
                <span className="schedule-icon header-text-style">
                  Schedule
                </span>
              </div>
            </div>
          ) : null}
        </>
      )}
      {classPermission ? (
        <>
          <div
            className={
              (`${isMobile ? '' : 'pl-3'}`,
              `${user?._id ? 'header-course-after' : ''}`,
              'header__nav-link')
            }
          >
            <span>
              <div
                className={classnames(
                  'cursor-pointer',
                  `${
                    viewMode !== 'LEARNER'
                      ? 'header-Learning'
                      : `${metaData?.cmsHomePage ? 'header-item' : ''}`
                  }`,
                )}
                style={{
                  display: 'flex',
                  '--menu-bg-clr': menuColor,
                  color: `${
                    metaData?.cmsHomePage
                      ? courseRoutePath.includes(Router?.pathname)
                        ? menuColor
                        : ''
                      : intakeRoutePath.includes(Router?.pathname)
                      ? menuColor
                      : ''
                  }`,
                }}
                onClick={courseClick}
              >
                <MdOutlineBackupTable className="header-icon-res " size={16} />

                <span className="course-icon header-text-style">
                  {metaData?.cmsHomePage ? 'Courses' : 'Classes'}
                </span>
              </div>
            </span>
          </div>
        </>
      ) : null}
      {!user?._id && (
        <>
          <div
            className={
              (`${isMobile ? '' : 'pl-3'} `,
              ' header__nav-link dashboard-left company-head-res')
            }
            onClick={companyClick}
          >
            <div>
              <div>
                <span className="home-icon">
                  <i
                    className="header-icon-res material-icons-outlined"
                    style={{ fontSize: 16, marginLeft: 4 }}
                  >
                    folder
                  </i>
                  <CompanyMenu />
                </span>
              </div>
            </div>
          </div>
        </>
      )}
      {metaData?.cmsHomePage && viewMode === 'LEARNER' && user?._id && (
        <>
          <div
            className={
              (`${isMobile ? '' : 'pl-3'}`,
              `${user?._id ? 'header-course-after' : ''}`,
              'header__nav-link')
            }
          >
            <div>
              <span>
                <div
                  className="header-Learning cursor-pointer"
                  style={{
                    display: 'flex',
                    '--menu-bg-clr': menuColor,
                    color: myLearningPath.includes(Router?.pathname)
                      ? menuColor
                      : '',
                  }}
                >
                  <MdOutlineLocalLibrary
                    className="header-icon-res"
                    style={{ fontSize: 16 }}
                  />

                  <span
                    className="workshop-icon header-text-style"
                    onClick={() => mylearningClick(user?._id)}
                  >
                    My Learning
                  </span>
                </div>
              </span>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
